import { NotebookPen } from 'lucide-react'
import Card from 'app/frontend/base/components/Card'
import RichTextContent from 'app/frontend/base/components/RichTextContent'
import NotesEditor, {
  hasNotesContent,
} from 'app/frontend/base/components/NotesEditor'
import RaidPlan from 'app/frontend/types/custom/RaidPlan'

type ControlProps = {
  raidPlan: RaidPlan
  canEdit: boolean
  isEditing: boolean
  onStartEdit: () => void
}

export const RaidPlanMessageControl = ({
  raidPlan,
  canEdit,
  isEditing,
  onStartEdit,
}: ControlProps) => {
  if (!canEdit || isEditing || hasNotesContent(raidPlan.message)) return null

  return (
    <button
      type='button'
      onClick={onStartEdit}
      className='group flex items-center gap-2 self-start rounded-md border border-transparent px-2 py-1 text-sm text-muted-foreground transition-colors hover:border-border hover:bg-accent'
      aria-label='Add message'
    >
      <NotebookPen className='h-3.5 w-3.5 opacity-60 transition-opacity group-hover:opacity-100' />
      <span>Add message</span>
    </button>
  )
}

type ContentProps = {
  raidPlan: RaidPlan
  isEditing: boolean
  onStopEdit: () => void
  onSave: (message: string) => Promise<void>
}

const RaidPlanMessageContent = ({
  raidPlan,
  isEditing,
  onStopEdit,
  onSave,
}: ContentProps) => {
  if (isEditing) {
    return (
      <NotesEditor
        initialValue={raidPlan.message ?? ''}
        onSave={onSave}
        onCancel={onStopEdit}
        clearTarget='this plan'
      />
    )
  }

  if (!hasNotesContent(raidPlan.message)) return null

  return (
    <Card>
      <RichTextContent content={raidPlan.message ?? ''} />
    </Card>
  )
}

export default RaidPlanMessageContent
